import Vue from "vue";
import Router from "vue-router";
import Home from "./views/HomeView.vue";

Vue.use(Router);

//let i18n;

export const shareRouter = new Router({
  mode: "history",
  routes: [
    // Different menus
    {
      path: "/:shareId",
      name: "home",
      component: Home,
      props: true
    },
    {
      path: "*",
      name: "not-found",
      component: () => import("./views/NotFound.vue")
    }
  ]
});
